import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { logActivity } from 'actions/logs';
import { setActiveSection } from 'actions/sections';
import { COMPULSORY_SCHOOL, PRESCHOOL, UPPER_SECONDARY_EDUCATION, ADULT_EDUCATION } from 'constants/schoolTypes';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import CompulsorySchoolSection from './SectionTypes/CompulsorySchoolSection';
import PreSchoolSection from './SectionTypes/PreSchoolSection';
import UpperSecondarySchoolSection from './SectionTypes/UpperSecondarySchoolSection';

var SectionWrapper = /*#__PURE__*/function (_Component) {
  _inherits(SectionWrapper, _Component);

  var _super = _createSuper(SectionWrapper);

  function SectionWrapper(props) {
    var _this;

    _classCallCheck(this, SectionWrapper);

    _this = _super.call(this, props);
    _this.state = {
      loading: false
    };
    return _this;
  }

  _createClass(SectionWrapper, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setActiveSection();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      //log the activity of loading the page
      var logJson = {
        LogType: "Route Change",
        ReferenceType: "Group Page",
        ReferenceId: this.props.match.params.groupId,
        Comment: "User loaded page"
      };
      this.props.logActivity(logJson);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.currentUser == null) {
        return;
      } else {
        switch (this.props.currentUser.schools.getActiveSchool(this.props.currentUser.userId).type) {
          case PRESCHOOL:
            return /*#__PURE__*/React.createElement(PreSchoolSection, null);

          case COMPULSORY_SCHOOL:
            return /*#__PURE__*/React.createElement(CompulsorySchoolSection, null);

          case UPPER_SECONDARY_EDUCATION:
            return /*#__PURE__*/React.createElement(UpperSecondarySchoolSection, null);

          case ADULT_EDUCATION:
            return /*#__PURE__*/React.createElement(UpperSecondarySchoolSection, null);

          default:
            return /*#__PURE__*/React.createElement("div", null);
        }
      }
    }
  }]);

  return SectionWrapper;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps, {
  setActiveSection: setActiveSection,
  logActivity: logActivity
})(SectionWrapper);